import { Quote, Sparkles, Target, UserRound, Users } from "lucide-react";

const PILLARS = [
  { Icon: UserRound, t: "One founder", d: "The educator who builds the programs is the one who teaches the sessions." },
  { Icon: Users, t: "Two audiences", d: "Grown-up learners and curious kids, each with a space made for them." },
  { Icon: Target, t: "Zero fluff", d: "Built for outcomes, not enrolment numbers." },
];

function QuoteMark({ className }) {
  return (
    <svg viewBox="0 0 100 80" fill="currentColor" className={className} aria-hidden>
      <path d="M0 80V48C0 22 14 6 40 0l4 10C30 15 22 25 21 40h19v40H0zm56 0V48C56 22 70 6 96 0l4 10C86 15 78 25 77 40h19v40H56z" />
    </svg>
  );
}

function OrbitArt() {
  return (
    <svg viewBox="0 0 220 130" className="mt-10 w-60 hidden md:block" aria-hidden>
      <defs>
        <linearGradient id="cws-orbit" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor="#F59E0B" /><stop offset="1" stopColor="#8B5CF6" /></linearGradient>
      </defs>
      <ellipse cx="110" cy="65" rx="100" ry="44" fill="none" stroke="#27272a" strokeDasharray="4 6" />
      <ellipse cx="110" cy="65" rx="62" ry="27" fill="none" stroke="#3f3f46" strokeDasharray="2 5" />
      <circle cx="110" cy="65" r="18" fill="url(#cws-orbit)" />
      <text x="110" y="70" textAnchor="middle" fontFamily="monospace" fontWeight="700" fontSize="13" fill="#09090B">&lt;/&gt;</text>
      <circle cx="210" cy="65" r="6" fill="#F59E0B"><animate attributeName="opacity" values="1;0.4;1" dur="3s" repeatCount="indefinite" /></circle>
      <circle cx="48" cy="65" r="5" fill="#8B5CF6"><animate attributeName="opacity" values="0.4;1;0.4" dur="3s" repeatCount="indefinite" /></circle>
      <circle cx="140" cy="22" r="3.5" fill="#FCD34D" />
      <circle cx="78" cy="106" r="3" fill="#A78BFA" />
    </svg>
  );
}

export function MissionSection({ why, photo }) {
  return (
    <section data-testid="founder-mission" className="max-w-7xl mx-auto px-6 py-20">
      <div className="relative overflow-hidden rounded-3xl border border-zinc-800 bg-gradient-to-br from-zinc-950 via-[#0d0b12] to-[#120d05] p-6 sm:p-10 md:p-14">
        <QuoteMark className="absolute -top-4 right-4 w-40 h-40 md:w-56 md:h-56 text-amber-500/[0.07]" />
        <div className="absolute inset-0 grain pointer-events-none" />
        <div className="relative grid md:grid-cols-5 gap-10">
          <div className="md:col-span-2">
            <div className="text-[11px] uppercase tracking-[0.28em] text-amber-400 font-adult-mono">Why I built this</div>
            <h2 className="mt-4 font-adult-heading text-3xl sm:text-4xl font-semibold tracking-tight leading-tight">
              The mission behind <span className="font-adult-serif italic text-amber-400">Code With Sankalp.</span>
            </h2>
            <OrbitArt />
          </div>
          <div className="md:col-span-3">
            <Quote className="w-8 h-8 text-amber-400" />
            <p data-testid="founder-why" className="mt-4 font-adult-heading text-xl md:text-2xl leading-relaxed text-zinc-100">{why}</p>
            <div className="mt-6 flex items-center gap-3">
              {photo && <img src={photo} alt="" className="w-11 h-11 rounded-full object-cover object-top border border-amber-500/40" />}
              <div>
                <div className="text-sm text-white">Sankalp Sidhanth Misra</div>
                <div className="text-[10px] uppercase tracking-[0.2em] font-adult-mono text-zinc-500">Founder</div>
              </div>
            </div>
          </div>
        </div>
        <div className="relative mt-12 grid sm:grid-cols-3 gap-4">
          {PILLARS.map(({ Icon, t, d }, i) => (
            <div key={t} data-testid={`mission-pillar-${i}`} className="group rounded-2xl border border-zinc-800 bg-black/30 p-5 transition-[transform,border-color] duration-300 hover:-translate-y-1 hover:border-violet-500/40">
              <div className="flex items-center justify-between">
                <span className="w-10 h-10 rounded-xl bg-violet-500/10 border border-violet-500/30 text-violet-300 flex items-center justify-center"><Icon className="w-5 h-5" /></span>
                <span className="font-adult-mono text-xs text-zinc-600">0{i + 1}</span>
              </div>
              <div className="mt-4 font-adult-heading text-lg">{t}</div>
              <p className="mt-1 text-sm text-zinc-400 leading-relaxed">{d}</p>
            </div>
          ))}
        </div>
        <div className="relative mt-8 inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-adult-mono text-violet-400">
          <Sparkles className="w-3.5 h-3.5" />One founder. Two audiences. Zero fluff.
        </div>
      </div>
    </section>
  );
}
